import React from 'react';
import isNil from 'lodash/isNil';
import { format } from 'date-fns';

export const getReadOnlyTime = (time) => time ? format(time, 'HH:mm') : '';

/**
 * A read only time component.
 *
 * @typedef {Object} ReadOnlyTimeProps
 * @property {Date} [value] The time value.
 *
 * @param {React.HTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & ReadOnlyTimeProps} props Component props.
 * @returns {React.ReactElement} Read only time component.
 */
const ReadOnlyTime = (props) => {
  const {
    value,
    placeholder = 'HH:mm',
  } = props;

  if (isNil(value)) {
    return (
      <div className="read-only empty">
        {placeholder}
      </div>
    );
  }

  return (
    <div className="read-only">
      {getReadOnlyTime(value)}
    </div>
  );
};

export default ReadOnlyTime;
